import { PaperclipIcon } from './PaperclipIcon';

/**
 * author: Google
 * id 27BCEC7F-ABF8-4506-B339-EE2425E1BAF9
 * name paperclip
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/paperclip.svg
 * tags
 */
export const AttachmentVerticalIcon = PaperclipIcon;
export default AttachmentVerticalIcon